// Activity, trace and audit streams: the routes of `core.host.observability` (ADR-0027).
// A core feature is on in each deployment.
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'core.host.observability',
    routes: [
        // Public service health. It sits beside `login` under RootLayout, so it
        // sees no authenticated layout, no sidebar and no agent panel.
        { frontend: 'public', path: 'status', lazy: () => import('@/pages/status/page') },
    ],
});
